import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../../../core/services/api.config';
import {
  ListPartnersResponse,
  UpsertPartnerRequest,
  UpsertPartnerResponse,
} from '../models/partner.models';

@Injectable({
  providedIn: 'root',
})
export class PartnersService {
  private readonly http = inject(HttpClient);
  private readonly apiBaseUrl = inject(API_BASE_URL);

  listPartners(): Observable<ListPartnersResponse> {
    return this.http.get<ListPartnersResponse>(`${this.apiBaseUrl}/partners`, {
      withCredentials: true,
    });
  }

  createPartner(payload: UpsertPartnerRequest): Observable<UpsertPartnerResponse> {
    return this.http.post<UpsertPartnerResponse>(`${this.apiBaseUrl}/partners`, payload, {
      withCredentials: true,
    });
  }

  updatePartner(partnerId: number, payload: UpsertPartnerRequest): Observable<UpsertPartnerResponse> {
    return this.http.patch<UpsertPartnerResponse>(`${this.apiBaseUrl}/partners/${partnerId}`, payload, {
      withCredentials: true,
    });
  }
}
